<template>
<div class="proDuctDetail">
  <van-swipe :autoplay="3000">
    <van-swipe-item v-for="(banner, index) in detailData.files" :key="index">
      <img v-lazy="banner" class="bannerImg"/>
    </van-swipe-item>
  </van-swipe>
  <div class="productBox">
    <div class="name">{{ detailData.name }}</div>
    <div class="integral">
      <div>{{ detailData.price }}<span>积分</span></div>
      <div class="monthSales">月售{{ detailData.saleNo }}份</div>
    </div>
  </div>
  <div class="bottom bt_w_100 bt_H_32">
    <div class="total">共计：<span>{{ detailData.price }}</span>积分</div>
    <div class="Immediately" @click="Immediately">立即兑换</div>
  </div>
  <div class="introTitle">商品详情</div>
  <div class="intro">{{ detailData.intro}}</div>
</div>
</template>

<script>
import { scoreGoodsDetail, scoreExchange } from '@api/integralMall'
export default {
  name: "proDuctDetail",
  data () {
    return {
      detailData: {}
    }
  },
  created () {
    this.goodsDetail()
  },
  methods: {
    goodsDetail () {
      scoreGoodsDetail({
        goodsId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    Immediately () {
      scoreExchange({
        goodsId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$toastMsg('兑换成功')
          this.$router.go(-1)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
.proDuctDetail{
  .productBox{
    background: #fff;
    padding: 12px;
    .name{
      @include add_size($font_size_17);
      font-weight: bold;
      color: #000;
      margin-bottom: 8px;
    }
    .integral{
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include add_size($font_size_20);
      font-weight: bold;
      color: #FF7519;
      span{
        @include add_size($font_size_14);
      }
      .monthSales{
        @include add_size($font_size_13);
        color: #999999;
        font-weight: normal;
      }
    }
  }
  .bottom{
    background: #fff;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .total{
      padding: 8px 16px;
      color: #333;
      @include add_size($font_size_16);
      span{
        color: #FF7519;
        font-weight: bold;
      }
    }
    .Immediately{
      width: 100px;
      height: 32px;
      line-height: 32px;
      background: #096CEF;
      opacity: 1;
      border-radius: 16px;
      font-size: 15px;
      color:#fff;
      text-align: center;
      margin-right: 16px;
    }
  }
  .bannerImg{
    height: 210px;
  }
  .introTitle{
    @include add_size($font_size_18);
    font-weight: bold;
    color: #000;
    margin: 15px 0 8px 15px;
  }
  .intro{
    background: #fff;
    padding: 16px;
    height: 54vh;
    @include add_size($font_size_16);
  }
}
</style>
